import { array, date, number, object, string } from "yup";

const HomeVisitSchema = object({
  patient: number().required("required").min(0, "required").nullable(),
  activities: array().of(number().required("required")).min(1, "required"),
  when: date()
    .min(
      new Date(Date.now() - (new Date().getHours() + 1) * 60 * 60 * 1000),
      "must be a present / future date"
    )
    .required("required"),
  time: string()
    .required("required")
    .matches(
      RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g),
      "must match 15:30 (24hrs)format"
    ),
  additionalNotes: string().trim(),
});

export const homeVisitInitialValues = {
  patient: null,
  activities: [],
  when: "",
  time: "",
  additionalNotes: "",
};

export default HomeVisitSchema;
